import { useEffect, useRef } from 'react'
import { useQueryParams } from '@fs/zion-router'
import { siteConfig } from '../config/site'

export const ConferencePreviewRedirect = ({ children }) => {
  const { query } = useQueryParams()
  const { previewConference } = query
  // store state in a ref to handle the edge case where the component could render more than once and cause multiple redirects
  const hasRedirected = useRef(false)

  const redirectUrl =
    previewConference && siteConfig.conferencePreviewRedirects[previewConference]
      ? siteConfig.conferencePreviewRedirects[previewConference]
      : null

  // Perform the navigation in useEffect to avoid side effects during render
  useEffect(() => {
    if (redirectUrl && !hasRedirected.current) {
      hasRedirected.current = true
      window.location.href = redirectUrl
    }
  }, [redirectUrl])

  if (redirectUrl) {
    return null
  }

  return children
}

export default ConferencePreviewRedirect
